// Simple pub/sub for option list updates so dropdowns refresh live when Manage dialog edits them.

export function notifyOptionsChanged(optionType) {
  window.dispatchEvent(new CustomEvent(`options-updated-${optionType}`));
}

export function subscribeOptionsChanged(optionType, handler) {
  const event = `options-updated-${optionType}`;
  window.addEventListener(event, handler);
  return () => window.removeEventListener(event, handler);
}
